import React from 'react';
import PropTypes from 'prop-types';

import classes from './WireTable.css';
import WireTableNotes from './WireTableNotes/WireTableNotes';
import conductSize from '../../../assets/data/AppData/Canada/WireData/ConductSize.json';
import translation from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const wireTable = props => {
  const { country, language, selectedAWG } = props;
  const maxConductorsNumber = require(`../../../assets/data/AppData/${country}/WireData/MaxConductorsNumber.json`);

  let maxNumConducTitle1 = `${translation[language]['RW75']}*`,
    maxNumConducTitle2 = `${translation[language]['T90']}*`;

  if (country === 'USA') {
    maxNumConducTitle1 = `${translation[language]['THW']}*`;
    maxNumConducTitle2 = `${translation[language]['THHN']}*`;
  }
  if (country === 'Canada') {
    maxNumConducTitle1 = `${translation[language]['RW75']}*`;
    maxNumConducTitle2 = `${translation[language]['T90']}*`;
  }

  const tableRows = [];
  for (let i = 0; i < conductSize.length; i++) {
    const currentConductor =
      maxConductorsNumber[selectedAWG].MaxConductorsNumber;
    const row = (
      <tr key={conductSize[i][1]}>
        <td>{conductSize[i][0]}</td>
        <td>{conductSize[i][1]}</td>
        <td>{currentConductor[i][0]}</td>
        <td>{currentConductor[i][1]}</td>
      </tr>
    );
    tableRows.push(row);
  }

  tableRows.reduce((arr, el) => arr.concat(el), []);

  return (
    <div className={classes.WireTable}>
      <div className={classes.SubTitels}>
        <h4>{translation[language].conductSize}</h4>
        <h4>{translation[language].maxConductNum}</h4>
      </div>
      <table>
        <thead>
          <tr>
            <th>{translation[language].inches}</th>
            <th>{translation[language].mm}</th>
            <th>{maxNumConducTitle1}</th>
            <th>{maxNumConducTitle2}</th>
          </tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </table>
      <WireTableNotes language={language} country={country} />
    </div>
  );
};

wireTable.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedAWG: PropTypes.string.isRequired
};

export default wireTable;
